module.exports = __webpack_public_path__ + "img/home-nav-hy-icon.d64bd8ce.png";